import { useEffect } from 'react'

export const APP_TITLE = 'Fruuit Engage'

export function formatTitle(...parts: (string | null | undefined | false)[]): string {
  return [...parts.filter((part): part is string => Boolean(part)), APP_TITLE].join(' · ')
}

/**
 * Per-route document title (GAP-UI-001, WCAG 2.4.2):
 * `useTitle('Dashboard')` → "Dashboard · Fruuit Engage";
 * `useTitle('Nordvik Shipping', 'Company')` → "Nordvik Shipping · Company · Fruuit Engage".
 */
export function useTitle(...parts: (string | null | undefined | false)[]): void {
  const title = formatTitle(...parts)
  useEffect(() => {
    document.title = title
  }, [title])
}
